/* AUTO-GENERATED FILE. DO NOT EDIT MANUALLY. */
/* Source: libs/laboratory/report-chat/src/components/report-chat-panel/translation/ru.json */
export const LABORATORY_REPORT_CHAT_PANEL_TRANSLATION_SCHEME = {
  closeAria: 'laboratoryReportChatPanel.closeAria',
  historyAria: 'laboratoryReportChatPanel.historyAria',
  supportTitle: 'laboratoryReportChatPanel.supportTitle',
  tsScope: 'laboratoryReportChatPanel',
} as const;
